<template>
  <div>
    <top-header v-bind:title="$t('ourFoodTrucks')">
      <header-button icon="mdi-plus-box"
                     right
                     slot="right-button"
                     v-if="hasRole('FoodTruckFinderAdministrator')"
                     v-bind:label="$t('new')"
                     v-bind:to="{ name: 'administration-food-truck-add' }" />

      <v-menu slot="menu"
       v-if="hasRole('FoodTruckFinderAdministrator')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn dark
                 text
                 v-bind="attrs"
                 v-on="on">
            <v-icon left>mdi-download</v-icon>
            {{ $t('export') }}
          </v-btn>
        </template>
        <v-list class="py-0">
          <v-list-item v-on:click="exportFoodTrucks(false)" >
            <v-list-item-title>{{ $t('active') }}</v-list-item-title>
          </v-list-item>
           <v-list-item v-on:click="exportFoodTrucks(true)" >
            <v-list-item-title>{{ $t('inactive') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

   
    </top-header>
    <v-container>
      <food-truck-administration-list-card v-bind:title="$t('ourFoodTrucks')"
                                           v-bind:foodTrucks="onlyFoodTrukcs" />
    </v-container>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  import HeaderButton from '@/components/common/HeaderButton'
  import TopHeader from '@/components/common/TopHeader'
  import FoodTruckAdministrationListCard from '@/components/FoodTruckAdministrationListCard'

  export default {
    components: {
      FoodTruckAdministrationListCard,
      HeaderButton,
      TopHeader
    },
    computed: {
      onlyFoodTrukcs() {
        return this.filteredFoodTrucks.filter(f => !f.partner)
      },
      ...mapGetters({
        filteredFoodTrucks: 'filteredFoodTrucks',
        hasRole: 'auth/hasRole'
      })
    },
    async created() {
      await this.loadFoodTrucks()
    },
    methods: {
      exportFoodTrucks(onlyInactive) {
        let sortedFoodTrucksById = this.onlyFoodTrukcs.sort((a, b) => a.id - b.id)

        if (onlyInactive) {
          sortedFoodTrucksById = sortedFoodTrucksById.filter(f => !!f.inactive)
        } else {
          sortedFoodTrucksById = sortedFoodTrucksById.filter(f => !f.inactive)
        }

        let csv = "Nummer;Name;Beschreibung;Special Facts;Adresse;PLZ;Stadt;Land;Region;Kategorie-Nr.;Kategorie;Weitere Kategorien;Webseite;E-Mail-Adresse;Telefon;Instagram;Facebook;Kooperationsinfo;Ansprechpartner;Maße;Strombedarf;Kassensystem;Notizen;Topseller Gericht;Output pro Stunde;Konditionen;Großhändler\n"

        csv += sortedFoodTrucksById.map(f => {
          console.log(f.regionGroup)
          const descriptionWithoutLineBreaks = f.description?.replace(/\n/g, ' ') ?? ''
          const notesWithoutLineBreaks = f.notes?.replace(/\n/g, ' ') ?? ''

          return `"${f.id ?? ''}";"${f.title ?? ''}";"${descriptionWithoutLineBreaks}";"${f.specialties ?? ''}";"${f.streetAddress ?? ''}";"${f.postalCode ?? ''}";"${f.city ?? ''}";"${f.country ?? ''}";"${f.regionGroup}";"${f.categoryId ?? ''}";"${f.category?.title ?? ''}";"${f.categories ?? ''}";"${f.web ?? ''}";"${f.email ?? ''}";"${f.phone ?? ''}";"${f.instagram ?? ''}";"${f.facebook ?? ''}";"${f.cooperationInformation ?? ''}";"${f.contactPerson ?? ''}";"${f.dimensions ?? ''}";"${f.powerRequirements ?? ''}";"${f.posSystem ?? ''}";"${notesWithoutLineBreaks}";"${f.topSellingDish ?? ''}";"${f.outputPerHour ?? ''}";"${f.termsAndConditions ?? ''}";"${f.wholesaler ?? ''}"`
        }).join('\n')


        let element = document.createElement('a')
        element.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(csv).replaceAll('#', '%23'))
        element.setAttribute('download', 'foodtrucks.csv')
        element.style.display = 'none'

        document.body.appendChild(element)

        element.click()

        document.body.removeChild(element)
      },
      ...mapActions([
        'loadFoodTrucks'
      ])
    },
    name: 'FoodTrucks'
  }
</script>

<i18n>
  {
    "de": {
      "ourFoodTrucks": "Unsere Foodtrucks",
      "new": "Neu",
      "export": "Exportieren",
      "active": "Aktive Foodtrucks",
      "inactive": "Inaktive Foodtrucks"
    },
    "en": {
      "ourFoodTrucks": "Our food trucks",
      "new": "New",
      "export": "Export",
      "active": "Active food trucks",
      "inactive": "Inactive food trucks"
    }
  }
</i18n>